import { render, staticRenderFns } from "./UserRow.vue?vue&type=template&id=0397cb3a&scoped=true"
import script from "./UserRow.vue?vue&type=script&lang=js"
export * from "./UserRow.vue?vue&type=script&lang=js"
import style0 from "./UserRow.vue?vue&type=style&index=0&id=0397cb3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0397cb3a",
  null
  
)

export default component.exports